import { Box, makeStyles, MenuItem, SvgIconTypeMap, Typography } from '@material-ui/core'
import { OverridableComponent } from '@material-ui/core/OverridableComponent'
import { withStyles } from '@material-ui/styles'
import { theme } from 'config'
import { useEffect, useState } from 'react'
import { CustomTooltip } from './CustomTooltip'

export interface ActionButtonProps {
  icon: string
  text: string
  onClick: (e: React.MouseEvent<HTMLLIElement, MouseEvent>) => void
  disabled?: boolean
  tooltip?: React.ReactNode | string
  withoutPadding?: boolean
  disabledTooltip?: string
  color?: 'primary' | 'secondary' | 'error' | 'variantSecondary'
  wordBreak?: 'normal' | 'break-all' | 'keep-all' | 'break-word'
  Icon?: OverridableComponent<SvgIconTypeMap<unknown, 'svg'>>
}

const ActionItem = withStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
    width: '75px',
    height: '86px',
    display: 'block',
    borderRadius: '5px',
  },
  // variantSecondary: {
  //   backgroundColor: theme.palette.lightBlue,
  // },
}))(MenuItem) as typeof MenuItem

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
    width: '75px',
    height: '86px',
    display: 'block',
    borderRadius: '5px',
  },
  variantSecondary: {
    backgroundColor: theme.palette.lightBlue,
  },
}))

export const ActionButton = ({
  text,
  icon,
  onClick,
  disabled,
  tooltip,
  withoutPadding,
  disabledTooltip,
  color = 'primary',
  wordBreak = 'normal',
  Icon,
  ...rest
}: ActionButtonProps): JSX.Element => {
  const [actionButtonColor, setActionButtonColor] = useState('')
  const classes = useStyles()

  useEffect(() => {
    switch (color) {
      case 'primary':
        return setActionButtonColor(theme.palette.primary.main)
      case 'secondary':
        return setActionButtonColor(theme.palette.black)
      case 'error':
        return setActionButtonColor(theme.palette.error.main)
      case 'variantSecondary':
        return setActionButtonColor(theme.palette.primary.main)
    }
  }, [color])

  const actionItemClassName = `${classes.root} ${
    color === 'variantSecondary' ? classes.variantSecondary : ''
  }`

  return (
    <CustomTooltip title={(disabled ? disabledTooltip : tooltip) || ''}>
      <Box
        paddingLeft={withoutPadding ? '0px' : '2px'}
        paddingRight={withoutPadding ? '0px' : '2px'}
        style={{
          color: `${actionButtonColor}`,
        }}
      >
        <ActionItem
          {...rest}
          className={actionItemClassName}
          style={{
            padding: withoutPadding ? '2px' : '4px',
            height: 'auto',
          }}
          disabled={disabled}
          onClick={onClick}
        >
          <Box
            width="fit-content"
            margin="0 auto"
            height="42px"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            {Icon !== undefined ? (
              <Icon
                htmlColor={disabled ? '#ADADAD' : actionButtonColor}
                style={{ fontSize: '24px' }}
              />
            ) : (
              <i
                color={disabled ? '#ADADAD' : actionButtonColor}
                style={{ fontSize: '24px' }}
                className={icon}
              />
            )}
          </Box>
          <Box
            width="auto"
            textAlign="center"
            height="22px"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Typography
              style={{
                lineHeight: '112%',
                whiteSpace: 'normal',
                display: 'block',
                marginTop: '0px',
              }}
              variant="caption"
            >
              {text}
            </Typography>
          </Box>
        </ActionItem>
      </Box>
    </CustomTooltip>
  )
}
